/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MdDeleteSweep } from "react-icons/md";
import moment from "moment";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import {
  useLookupCashCenters,
  useLookupCities,
  useLookupOffices,
} from "../../services/lookups-mutations";
import {
  useGetVehicleDetails,
  useUpdateVehicles,
} from "../../services/vehicles";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import FormInput from "../../components/forms/form-Input";
import FormHookDatePicker from "../../components/forms/form-hook-date-picker";
import NumericInput from "../../components/forms/react-hook-numeric-input";
import { makeEditPayload } from "./utils";
import {
  DEFAULT_VEHICLE,
  EMPTY_LOCK,
  EMPTY_PICTURES,
  REGISTRATION_TYPES,
  STATUS_LIST,
  VEHICLE_TYPES,
} from "./constants";
import { Textarea } from "@repo/ui";
import { useGetUsersList } from "services/auth-api";
import { useLookupCurrency } from "services/lookups-queries";

export default function UpdateVehicle() {
  const [vehicle, setVehicle] = useState({
    ...DEFAULT_VEHICLE,
  });

  const { data: currencyListRes, isPending: gettingCurrencyList } =
    useLookupCurrency();

  const navigate = useNavigate();

  const params = useParams();
  const {
    handleSubmit,
    control,
    watch,
    getValues,
    reset,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...DEFAULT_VEHICLE,
      ...EMPTY_LOCK,
      ...EMPTY_PICTURES,
    },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    cashCenterId: { required: "Please Select Cash Center" },
    fleetNo: { required: "Please Enter Fleet No" },
    registrationNo: { required: "Please Enter Registration No" },
    make: { required: "Please Enter Make" },
    model: { required: "Please Enter Model" },
    manufacturingYear: {
      required: "Please Select Manufacturing Year",
      validate: (value) => {
        if (value > Number(moment().year())) {
          return "Please Enter Valid Year";
        }
        return true;
      },
    },
    registrationYear: {
      validate: (value) => {
        if (value > Number(moment().year())) return "Please Enter Valid Year";
        return true;
      },
    },
    vanType: { required: "Please Select Van Type" },
    cashLimit: {
      required: "Cash Limit is Required",
      validate: (value) => {
        if (Number(value) === 0 || Number(value) < 0) {
          return "Enter Valid Value";
        }
        return true;
      },
    },
    currency: { required: "Currency is Required" },
  };
  const {
    fields: installedLocksList,
    remove: installedLocksRemove,
    append: addLocks,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "installedLocks",
  });

  const { mutate: getCities, data: citiesList } = useLookupCities();

  const { data: employees, mutate: getUsersList } = useGetUsersList();
  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
  } = useLookupCashCenters();
  const {
    mutate: getOffices,
    data: officesList,
    reset: resetOffices,
  } = useLookupOffices();

  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    isPending: creatingRequest,
  } = useUpdateVehicles();
  const {
    mutate: getVehicle,
    data: vehicleRes,
    isPending: gettingVehicle,
    reset: resetVehicle,
  } = useGetVehicleDetails();
  useEffect(() => {
    if (isRequestCreated) {
      navigate(Paths.vehiclesList);
    }

    if (vehicleRes) {
      if (vehicleRes?.data.cashCenterId && !officesList) {
        getOffices(vehicleRes.data.cashCenterId);
      }
      if (cashCenterList && officesList) {
        const _data = makeEditPayload(
          vehicleRes?.data,
          cashCenterList?.data || [],
          officesList?.data || [],
        );
        setVehicle({
          ..._data,
        });
        reset({
          ...DEFAULT_VEHICLE,
          ...EMPTY_LOCK,
          ...EMPTY_PICTURES,
          ..._data,
        });
        resetVehicle();
      }
    }
  }, [isRequestCreated, vehicleRes, cashCenterList, officesList]);

  useEffect(() => {
    getCashCenter();
    getCities("UAE");
    if (params.vehicleId) {
      getVehicle(params.vehicleId);
    }
    getUsersList();
  }, []);

  const onCashCenterChange = (_value) => {
    const findCashCenter = cashCenterList.data.find(
      (item) => item.cashCenterId === _value,
    );
    setValue("cashCenterName", findCashCenter?.name || "");
    if (!_value || _value === "0") {
      resetOffices();
    } else {
      getOffices(_value);
    }
    setValue("officeId", "", {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  const onOfficeChange = (_value) => {
    const findOfficeName = officesList.data.find(
      (item) => item.officeId === _value,
    );
    setValue("officeName", findOfficeName?.officeName || "");
  };

  const addLock = () => {
    const data = getValues();
    clearErrors(["lockType", "lockSerilNo", "vender"]);
    let isDataValid = true;
    if (!data.lockType) {
      setError("lockType", {
        type: "required",
        message: "Please Enter Lock Type",
      });
      isDataValid = false;
    }
    if (!data.vender) {
      setError("vender", {
        type: "required",
        message: "Please Enter Vender",
      });
      isDataValid = false;
    }
    if (!data.lockSerilNo) {
      setError("lockSerilNo", {
        type: "required",
        message: "Please Enter Lock Serial No",
      });
      isDataValid = false;
    }
    if (!isDataValid) return;
    const lock = {
      lockType: data.lockType,
      vender: data.vender,
      lockSerilNo: data.lockSerilNo,
    };
    setValue("lockType", "");
    setValue("vender", "");
    setValue("lockSerilNo", "");
    addLocks(lock);
  };
  const onSave = (data) => {
    const payload = {
      vehicleId: data.vehicleId || vehicle.id,
      cashCenterId: data.cashCenterId,
      cashCenterName: data.cashCenterName,
      officeId: data.officeId,
      officeName: data.officeName,
      fleetNo: data.fleetNo,
      registrationNo: data.registrationNo,
      make: data.make,
      model: data.model,
      manufacturingYear: data.manufacturingYear,
      vanType: data.vanType,
      engineNo: data.engineNo,
      chassisNo: data.chassisNo,
      color: data.color,
      city: data.city,
      purchaseDate: data.purchaseDate,
      registrationType: data.registrationType,
      registrationYear: data.registrationYear,
      registrationExpiry: data.registrationExpiry,
      insurer: data.insurer,
      insuranceExpiry: data.insuranceExpiry,
      armouredBy: data.armouredBy,
      currency: data.currency,
      armouringDate: data.armouringDate,
      lastFitnessDate: data.lastFitnessDate,
      fitnessDueDate: data.fitnessDueDate,
      fitnessInterval: data.fitnessInterval,
      fuelTag: data.fuelTag,
      cashLimit: Number(data.cashLimit || 0),
      status: data.status || "",
      issuedTo: data.issuedTo,
      installedLocks: data.installedLocks.map((elm) => ({
        lockType: elm.lockType,
        vender: elm.vender,
        lockSerilNo: elm.lockSerilNo,
      })),
      pictures: data.pictures,
      requestedBy: data.requestedBy,
      comments: data.comments,
    };

    createRequest(payload);
  };

  return (
    <>
      {gettingCashCenterList ||
      creatingRequest ||
      !vehicle.vehicleId ||
      gettingVehicle ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Vehicles", link: Paths.vehiclesList },
            { text: "Edit Vehicle", isCurrentPage: true },
          ]}
        />

        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div className="add-location-form">
                {vehicle.vehicleId ? (
                  <form onSubmit={handleSubmit(onSave)}>
                    <ReactHookFormDropdown
                      {...generalFieldProps}
                      isRequired
                      label="Cash Center"
                      name="cashCenterId"
                      data={
                        cashCenterList?.data.map((item) => ({
                          value: item.cashCenterId,
                          label: item.name,
                        })) || []
                      }
                      placeholder="Select Cash Center"
                      rules={formValidationRules.cashCenterId}
                      onChange={onCashCenterChange}
                    />
                    <ReactHookFormDropdown
                      {...generalFieldProps}
                      label="Office"
                      name="officeId"
                      data={
                        officesList?.data.map((item) => ({
                          value: item.officeId,
                          label: item.officeName,
                        })) || []
                      }
                      placeholder="Select Offices"
                      onChange={onOfficeChange}
                    />
                    <FormInput
                      {...generalFieldProps}
                      isRequired
                      label="Fleet No"
                      name="fleetNo"
                      rules={formValidationRules.fleetNo}
                    />
                    <FormInput
                      {...generalFieldProps}
                      isRequired
                      label="Registration No"
                      name="registrationNo"
                      rules={formValidationRules.registrationNo}
                    />
                    <FormInput
                      {...generalFieldProps}
                      isRequired
                      label="Make"
                      name="make"
                      rules={formValidationRules.make}
                    />
                    <FormInput
                      {...generalFieldProps}
                      isRequired
                      label="Model"
                      name="model"
                      rules={formValidationRules.model}
                    />
                    <NumericInput
                      {...generalFieldProps}
                      isRequired
                      label="Manufacturing Year"
                      name="manufacturingYear"
                      inputProps={{ format: "#", className: "hide-spinners" }}
                      rules={formValidationRules.manufacturingYear}
                    />
                    <ReactHookFormDropdown
                      {...generalFieldProps}
                      isRequired
                      required
                      label="Van Type"
                      name="vanType"
                      data={VEHICLE_TYPES}
                      placeholder="Select Van Type"
                      rules={formValidationRules.vanType}
                    />
                    <FormInput
                      {...generalFieldProps}
                      label="Engine No"
                      name="engineNo"
                    />
                    <FormInput
                      {...generalFieldProps}
                      label="Chassis No"
                      name="chassisNo"
                    />
                    <FormInput
                      {...generalFieldProps}
                      label="Color"
                      name="color"
                    />
                    <ReactHookFormDropdown
                      {...generalFieldProps}
                      required
                      label="City"
                      name="city"
                      data={
                        citiesList?.data.map((item) => ({
                          value: item.name,
                          label: item.name,
                        })) || []
                      }
                      placeholder="Select City"
                    />
                    <FormHookDatePicker
                      {...generalFieldProps}
                      datePickerProps={{
                        placeholder: "Select Purchase Date",
                      }}
                      label="Purchase Date"
                      name="purchaseDate"
                    />
                    <ReactHookFormDropdown
                      {...generalFieldProps}
                      required
                      label="Registration Type"
                      name="registrationType"
                      id="id"
                      text="text"
                      data={REGISTRATION_TYPES}
                      placeholder="Select Registration Type"
                    />
                    <NumericInput
                      {...generalFieldProps}
                      label="Registration Year"
                      name="registrationYear"
                      inputProps={{ format: "#", className: "hide-spinners" }}
                      rules={formValidationRules.registrationYear}
                    />
                    <FormHookDatePicker
                      {...generalFieldProps}
                      datePickerProps={{
                        placeholder: "Select Registration Expiry",
                      }}
                      label="Registration Expiry"
                      name="registrationExpiry"
                    />
                    <FormInput
                      {...generalFieldProps}
                      label="Insurer"
                      name="insurer"
                    />
                    <FormHookDatePicker
                      {...generalFieldProps}
                      datePickerProps={{
                        placeholder: "Select Insurance Expiry",
                      }}
                      label="Insurance Expiry"
                      name="insuranceExpiry"
                    />
                    <FormInput
                      {...generalFieldProps}
                      label="Armoured By"
                      name="armouredBy"
                    />
                    <FormHookDatePicker
                      {...generalFieldProps}
                      datePickerProps={{
                        placeholder: "Select Armouring Date",
                      }}
                      label="Armouring Date"
                      name="armouringDate"
                    />
                    <FormHookDatePicker
                      {...generalFieldProps}
                      datePickerProps={{
                        placeholder: "Select Last Fitness Date",
                      }}
                      label="Last Fitness Date"
                      name="lastFitnessDate"
                    />
                    <FormHookDatePicker
                      {...generalFieldProps}
                      datePickerProps={{
                        placeholder: "Select Fitness Due Date",
                      }}
                      label="Fitness Due Date"
                      name="fitnessDueDate"
                    />
                    <FormInput
                      {...generalFieldProps}
                      label="Fitness Interval"
                      name="fitnessInterval"
                    />
                    <ReactHookFormDropdown
                      {...generalFieldProps}
                      isRequired={watch("vanType") === "Cash Van"}
                      filterable
                      label="Currency"
                      name="currency"
                      data={
                        currencyListRes?.data?.map((currency) => ({
                          value: currency.shortName,
                          label: currency.name,
                        })) || []
                      }
                      placeholder="Select Currency"
                      rules={
                        watch("vanType") === "Cash Van"
                          ? formValidationRules.currency
                          : undefined
                      }
                    />
                    <FormInput
                      {...generalFieldProps}
                      isRequired={watch("vanType") === "Cash Van"}
                      label="Cash Limit"
                      inputProps={{ type: "number" }}
                      name="cashLimit"
                      rules={
                        watch("vanType") === "Cash Van"
                          ? formValidationRules.currency
                          : undefined
                      }
                    />
                    <ReactHookFormDropdown
                      {...generalFieldProps}
                      required
                      label="Status"
                      name="status"
                      id="id"
                      text="text"
                      data={STATUS_LIST}
                      placeholder="Select Status"
                    />
                    <FormInput
                      {...generalFieldProps}
                      label="Issued To"
                      name="issuedTo"
                    />{" "}
                    <FormInput
                      {...generalFieldProps}
                      label="Requested By"
                      name="requestedBy"
                    />
                    <FormControl>
                      <FormLabel style={{ visibility: "hidden" }}>
                        Fuel Tag
                      </FormLabel>
                      <Controller
                        control={generalFieldProps.control}
                        name="fuelTag"
                        render={({ field }) => {
                          return (
                            <Checkbox
                              isChecked={field.value}
                              onChange={field.onChange}
                            >
                              <FormLabel style={{ margin: 0 }}>
                                Fuel Tag
                              </FormLabel>
                            </Checkbox>
                          );
                        }}
                      />
                    </FormControl>
                    <div
                      className="full-width-field"
                      style={{ gridColumn: "span 4" }}
                    >
                      <FormControl>
                        <FormLabel>Comments</FormLabel>
                        <Controller
                          control={control}
                          name="comments"
                          render={({ field }) => (
                            <Textarea
                              value={field.value}
                              onChange={(e) => field.onChange(e.target.value)}
                            />
                          )}
                        />
                      </FormControl>
                    </div>
                    <Heading
                      style={{
                        width: "100%",
                        fontSize: "14px",
                        borderTop: `1px solid var(--primary-light)`,
                        padding: "10px 0px",
                        margin: 0,
                      }}
                    >
                      Installed Locks
                    </Heading>
                    <FormInput
                      {...generalFieldProps}
                      isRequired
                      label="Lock Type"
                      name="lockType"
                    />
                    <FormInput
                      {...generalFieldProps}
                      isRequired
                      label="Vender"
                      name="vender"
                    />
                    <FormInput
                      {...generalFieldProps}
                      isRequired
                      label="Lock Serial No"
                      name="lockSerilNo"
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "16px",
                      }}
                    >
                      <Button onClick={addLock} type="button">
                        Add Lock
                      </Button>
                    </div>
                    <Grid data={installedLocksList}>
                      <GridColumn title="Lock Type" field="lockType" />
                      <GridColumn title="Vender" field="vender" />
                      <GridColumn title="Lock Serial No" field="lockSerilNo" />
                      <GridColumn
                        title="Delete"
                        headerClassName="text-center"
                        width={80}
                        cell={({ dataIndex }) => (
                          <td>
                            <Flex
                              title="Delete Lock"
                              cursor="pointer"
                              onClick={() => {
                                installedLocksRemove(dataIndex);
                              }}
                            >
                              <MdDeleteSweep fontSize="18px" color="red" />
                            </Flex>
                          </td>
                        )}
                      />
                    </Grid>
                    {/* <Heading
                    style={{
                      width: "100%",
                      fontSize: "14px",
                      borderTop: `1px solid var(--primary-light)`,
                      padding: "10px 0px",
                      margin: 0,
                    }}
                  >
                    Pictures
                  </Heading>
                  <FormControl>
                    <FormLabel>Upload Picture</FormLabel>
                    <input
                      type={"file"}
                      accept="image/*"
                      onChange={(e) => {
                      }}
                    />
                  </FormControl> */}
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "16px",
                        borderTop: `1px solid var(--primary-light)`,
                        padding: "10px 0px",
                      }}
                    >
                      <Button type="submit">Update Vehicle</Button>
                    </div>
                  </form>
                ) : (
                  <></>
                )}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
